module.exports = __webpack_public_path__ + "media/images/categories/sensitive-40e5f06eccbec4d82251aa0e23971e7c.png";